import React, { createContext, useContext, useState, useCallback } from 'react';
import { SPORTS } from '../config/sportCapabilities';

/**
 * SportContext -- Active sport selection for Performance OS.
 * Persists to localStorage. Does NOT call APIs (front-only for now).
 */

const STORAGE_KEY = 'arenastats_active_sport';

const SportContext = createContext();

export const useSport = () => {
  const context = useContext(SportContext);
  if (!context) {
    throw new Error('useSport must be used within a SportProvider');
  }
  return context;
};

const loadSaved = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SPORTS.some((s) => s.key === saved)) return saved;
  } catch (_) {
    // SSR / privacy mode
  }
  return SPORTS[0]?.key || 'football';
};

export const SportProvider = ({ children }) => {
  const [activeSport, setActiveSportState] = useState(loadSaved);

  const setActiveSport = useCallback((key) => {
    if (SPORTS.some((s) => s.key === key)) {
      setActiveSportState(key);
      try {
        localStorage.setItem(STORAGE_KEY, key);
      } catch (_) {
        // ignore
      }
    }
  }, []);

  const activeSportObj = SPORTS.find((s) => s.key === activeSport) || SPORTS[0];

  return (
    <SportContext.Provider value={{ activeSport, activeSportObj, setActiveSport, sports: SPORTS }}>
      {children}
    </SportContext.Provider>
  );
};
